import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import { gettext } from "web/script/modules/django-i18n";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./homepage-category-links.css";
export var LINK_LIMIT = 9;

function HomepageCategoryLink(_ref) {
  var type = _ref.type,
      isOpen = _ref.isOpen,
      _onClick = _ref.onClick;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var hideLinks = type.links.length > LINK_LIMIT;
  return React.createElement("div", {
    className: styles.link
  }, React.createElement("button", {
    className: styles.linkTitleContainer,
    type: "button",
    onClick: function onClick() {
      return _onClick();
    }
  }, React.createElement("h4", {
    className: styles.linkTitle
  }, type.title), isOpen ? React.createElement(SVGIcon, {
    name: "minus",
    className: styles.plusMinusIcon
  }) : React.createElement(SVGIcon, {
    name: "plus",
    className: styles.plusMinusIcon
  })), React.createElement("div", {
    className: classnames(styles.linkTrends, _defineProperty({}, styles.open, isOpen))
  }, React.createElement("ul", {
    className: classnames(_defineProperty({}, styles.hideLinks, hideLinks && !isExpanded))
  }, type.links.map(function (link) {
    return React.createElement("li", {
      key: link.url
    }, React.createElement("a", {
      href: link.url,
      className: styles.linkTrendText
    }, link.title));
  })), hideLinks && !isExpanded && React.createElement("button", {
    className: styles.moreButton,
    type: "button",
    onClick: function onClick() {
      return setIsExpanded(true);
    }
  }, "+", gettext("burger_menu.more_category_link") // More
  )));
}

function HomepageCategoryLinks(_ref2) {
  var genericTypes = _ref2.genericTypes;
  var id = "homepage-category-links-rail";

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      openBlockId = _useState4[0],
      setOpenBlockId = _useState4[1];

  function setOpenBlock(blockId) {
    if (blockId == openBlockId) {
      // close everything
      setOpenBlockId(null);
    } else {
      // Set the new active block
      setOpenBlockId(blockId);
    }
  }

  function handleDrag() {
    analytics.event("rail", "drag", id);
  }

  return React.createElement("div", {
    className: styles.linksBase
  }, React.createElement(DragRail, {
    id: id,
    onDragStart: handleDrag
  }, React.createElement("div", {
    className: styles.linksDragRailContainer
  }, genericTypes.map(function (item) {
    return React.createElement(HomepageCategoryLink, {
      key: item.title,
      type: item,
      isOpen: openBlockId == item.title,
      onClick: function onClick() {
        return setOpenBlock(item.title);
      }
    });
  }))));
}

export default HomepageCategoryLinks;